import type { IconProps } from "@expo/vector-icons/build/createIconSet";
import createIconSetFromFontello from "@expo/vector-icons/createIconSetFromFontello";
import type { IconVariant } from "@qendo/theme";
import { useFonts } from "expo-font";
import { useTheme } from "~/providers/ThemeProvider";
import fontelloConfig from "../assets/icon/config.json";

const Icon = createIconSetFromFontello(fontelloConfig, "qendo", "qendo.ttf");

export type QendoIconProps = {
    variant?: IconVariant;
} & IconProps<QendoIconSet>;

export const QendoIcon = ({ name = "placeholder", color, variant = "primary", ...iconProps }: QendoIconProps) => {
    const { colours } = useTheme();
    const [fontsLoaded] = useFonts({
        qendo: require("../assets/icon/font/qendo.ttf"),
    });

    if (!fontsLoaded) {
        return null;
    }

    return <Icon {...iconProps} name={name} color={color ?? colours.icon[variant]} />;
};

export type QendoIconSet =
    | "acne"
    | "acid-reflux"
    | "acupuncture"
    | "alcohol"
    | "alternating-arrows"
    | "ambulance"
    | "anxious"
    | "apple"
    | "bathtub"
    | "bed"
    | "bell"
    | "bell-notification"
    | "bleeding"
    | "bloating"
    | "bloating-1"
    | "bookmark"
    | "bookmark-selected"
    | "books"
    | "bowel-activity"
    | "breast-tenderness"
    | "caffeine"
    | "calendar"
    | "care-team"
    | "checkmark"
    | "checkmark-circle"
    | "checkmark-thicker"
    | "checkmark-thin"
    | "chevron-down"
    | "chevron-left"
    | "chevron-right"
    | "chevron-up"
    | "circle"
    | "circle-lg-filled"
    | "circle-lg-outline"
    | "circle-md-filled"
    | "circle-sm-filled"
    | "cleaning"
    | "clock"
    | "clotting"
    | "cog"
    | "concentration"
    | "constipation"
    | "contact"
    | "cramping"
    | "cycle"
    | "denied"
    | "depressed"
    | "dizzy"
    | "doctor"
    | "drop"
    | "drops"
    | "dry-mouth"
    | "edit"
    | "ellipsis"
    | "ellipsis-horizontal"
    | "email"
    | "energy-level"
    | "exams"
    | "exercise"
    | "external-link"
    | "facebook"
    | "facebook-2"
    | "facial-hair"
    | "family-time"
    | "fatigue"
    | "feedback"
    | "file"
    | "filter"
    | "flag"
    | "flight"
    | "food"
    | "gardening"
    | "gas"
    | "google"
    | "hair"
    | "headset"
    | "health-app"
    | "health-clipboard"
    | "health-profile"
    | "heart"
    | "heart-plus"
    | "heat-pack"
    | "help-circle"
    | "home"
    | "hospital-visit"
    | "image"
    | "info"
    | "info-circle"
    | "ivf"
    | "journal"
    | "key"
    | "list"
    | "location"
    | "lock"
    | "massage"
    | "medical-bag"
    | "medical-clipboard"
    | "medical-profile"
    | "medication"
    | "menu"
    | "messages"
    | "microphone"
    | "migraine-headache"
    | "minus"
    | "miscarriage"
    | "mood"
    | "mood-happy"
    | "mood-neutral"
    | "mood-sad"
    | "mood-very-happy"
    | "mood-very-sad"
    | "moon"
    | "movement"
    | "nauseous"
    | "night-sweats"
    | "notebook"
    | "other"
    | "ovulation"
    | "pain"
    | "paperclip"
    | "pen"
    | "phone"
    | "placeholder"
    | "play-filled"
    | "play-in-circle"
    | "play-outline"
    | "plus"
    | "pregnant"
    | "prescribed"
    | "prescribed-file"
    | "profile"
    | "relaxation"
    | "repeat"
    | "report"
    | "resources"
    | "search"
    | "sex"
    | "share"
    | "shield"
    | "shopping"
    | "sitting"
    | "smoking"
    | "social-event"
    | "sparkle"
    | "star-of-life"
    | "stressed"
    | "sun"
    | "surgery"
    | "swelling"
    | "symptoms"
    | "temperature"
    | "tens-machine"
    | "termination"
    | "time-off-work"
    | "toilet"
    | "toilet-paper"
    | "trash"
    | "urine"
    | "vaccine"
    | "view-off"
    | "view-on"
    | "vomitting"
    | "warning-filled"
    | "warning-outline"
    | "water"
    | "work"
    | "xmark"
    | "zap"
    | "zap-filled";
